/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_DoneInputs */

const en_timer_done = /** @type {(inputs: Timer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time's up`)
};

const de_timer_done = /** @type {(inputs: Timer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit ist um`)
};

/**
* | output |
* | --- |
* | "Time's up" |
*
* @param {Timer_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_done = /** @type {((inputs?: Timer_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_done(inputs)
	return en_timer_done(inputs)
});